var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseModal = function SvgCloseModal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m1 1 9.9 9.9Z",
    fill: "#9AA0AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m1 1 9.9 9.9",
    stroke: "#9AA0AB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9 1 1 10.9Z",
    fill: "#9AA0AB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9 1 1 10.9",
    stroke: "#9AA0AB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
export { SvgCloseModal as ReactComponent };
export default "data:image/svg+xml,%3Csvg width='14' height='14' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M1 1L10.8995 10.8995Z' fill='%239AA0AB'/%3E %3Cpath d='M1 1L10.8995 10.8995' stroke='%239AA0AB' stroke-width='1.5' stroke-linecap='round'/%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M10.8995 1L1 10.8995Z' fill='%239AA0AB'/%3E %3Cpath d='M10.8995 1L1 10.8995' stroke='%239AA0AB' stroke-width='1.5' stroke-linecap='round'/%3E %3C/svg%3E";